// extracted by mini-css-extract-plugin
export default {"content":"ContactPage_content__B5aMF","section":"ContactPage_section__GYxqh","title":"ContactPage_title__PKl9O","card":"ContactPage_card__qVfiE"};